import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';
import {awsConfig} from '../../shared/config';

import * as RestCallHelper from '../../utils/network/RestCallHelper';
import {setBucket, addToBucket} from './ActionCreatorsBucket';
import * as AuthC from '../../utils/auth/AuthCognito';

const clientSubconLoading = (loadCriteria) => ({
    type: ActionTypes.CLIENT_SUBCONS_LOADING,
    payload: loadCriteria
});

const subcontractedLoading = (loadCriteria) => ({
    type: ActionTypes.CLIENT_SUBCONTRACTED_LOADING,
    payload: loadCriteria
});

const clientSubconsFailed = (errmess) => ({
    type: ActionTypes.CLIENT_SUBCONS_FAILED,
    payload: errmess
});

const subcontractedFailed = (errmess) => ({
    type: ActionTypes.CLIENT_SUBCONTRACTED_FAILED,
    payload: errmess
});

const addClientSubcon = (subcon) => ({
    type: ActionTypes.ADD_CLIENT_SUBCON,
    payload: subcon
});

const updateClientSubcon = (subcon) => ({
    type: ActionTypes.UPDATE_CLIENT_SUBCON,
    payload: subcon
});


const addClientSubcontractors = (subcontractors) => ({
    type: ActionTypes.ADD_CLIENT_SUBCONS,
    payload: subcontractors
});

const addSubcontracted = (subcontractors) => ({
    type: ActionTypes.ADD_CLIENT_SUBCONTRACTED,
    payload: subcontractors
});

const addSubcontractedBCU = (subcontractors) => ({
    type: ActionTypes.ADD_CLIENT_SUBCONTRACTED_BCU,
    payload: subcontractors
});

const subcontractedBCUFailed = (errmess) => ({
    type: ActionTypes.CLIENT_SUBCONTRACTED_BCU_FAILED,
    payload: errmess
});


// Returns Subcontractors of clientId
export const fetchClientSubcontractanti = (clientId) => (dispatch) => {

    if(!clientId)
        return;

    const params = {
        clientId: clientId
    };

    const urlParams = new URLSearchParams(params);
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.CLIENTS_SUBCON}?${urlParams}`);

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    dispatch(clientSubconLoading({clientId: clientId}));

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(subcons => dispatch(addClientSubcontractors(subcons)))
        .catch(error => {
            dispatch(clientSubconsFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Subcontractorilor" } }));
        });
}


// Returns who clientId is subcontracting for
export const fetchSubcontracted = (clientId) => (dispatch) => {

    if(!clientId)
        return;

    const params = {
        clientId: clientId,
        subcontracted: true
    };

    const urlParams = new URLSearchParams(params);
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.CLIENTS_SUBCON}?${urlParams}`);

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    dispatch(subcontractedLoading({clientId: clientId}));

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(subcons => dispatch(addSubcontracted(subcons)))
        .catch(error => {
            dispatch(subcontractedFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Subcontractorilor" } }));
        });
}

// Returns and load the subcontracted clients for current user
// We pass in the clientId for the user since at login, it i possible that this method ends up updated before the Redux Store
export const fetchSubcontractedBCU = (clientId) => (dispatch) => {

    if(!clientId)
        return;

    const params = {
        clientId: clientId,
        subcontracted: true
    };

    const urlParams = new URLSearchParams(params);
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.CLIENTS_SUBCON}?${urlParams}`);

    RestCallHelper.fetchAsJson(url)
        .then(subcons => dispatch(addSubcontractedBCU(subcons)))
        .catch(error => {
            dispatch(subcontractedBCUFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Subcontractorilor pentru Utilizatorul curent" } }));
        });
}


export const postClientSubcon = (subcontractor) => (dispatch) => {
    subcontractor.createDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.CLIENTS_SUBCON, {
        method: "POST",
        body: JSON.stringify(subcontractor),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(nSubcon => dispatch(addClientSubcon(nSubcon)) )
        .then(subconAction => dispatch(setBucket({ mostRecentClientSubconId: subconAction.payload.id, snackbar: { open: true, severity: "success", message: "Subcontractorul a fost creat cu succes" } })))
        .catch(error => {
            dispatch(clientSubconsFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul crearii Subcontractorului" } }));
        })
}


export const patchClientSubcon = (subcontractor) => (dispatch) => {
    subcontractor.updateDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    const urlParams = new URLSearchParams({ clientId: subcontractor.generalSection.subconForClientId });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.CLIENTS_SUBCON}/${subcontractor.id}?${urlParams}`);

    return fetch(url.href, {
            method: "PATCH",
        body: JSON.stringify(subcontractor),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(subcon => dispatch(updateClientSubcon(subcon)))
        .then(subconAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Datele Subcontractorului actualizate cu succes" } })))
        .catch(error => {
            dispatch(clientSubconsFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul actualizarii Subcontractorului" } }));
        });
}